module.exports = __webpack_public_path__ + "web-assets/img/mine_bgg.b623404b.png";